{
    "oversized": {
        "title": "WARNING!",
        "body": "Please note that when calculating international groupage shipments online, there are restrictions for countries such as Denmark, Spain, Ireland, Luxembourg, Malta, Germany, Norway, Portugal, Switzerland, Sweden, Turkey: maximum total weight up to 3000 kg, maximum unit weight - 1500 kg; length up to 2.4 meters, width up to 2.4 m and height up to 2.2 m. For other countries: total weight up to 5000 kg, maximum unit weight - 1500 kg; length up to 4 meters, width up to 2.4 m and height up to 2.2 m. For cargo exceeding these parameters, individual processing is provided."
    },
    "loadingWithTailLift": {
        "body": "For cargo transported by hydroboard vehicles, the maximum width is 2 m, and the maximum weight is 750 kg. For cargoes that exceed these parameters, individual processing is provided."
    },
    "email": "Incorrect e-mail entered",
    "required": {
        "field": "Field is required"
    },
    "minPassword": {
        "field": "Password must be at least {{count}} characters long"
    },
    "passwordsMustMatch": {
        "field": "Passwords must match"
    },
    "isPhoneNumber": {
        "field": "Invalid phone number"
    },
    "passwordRequirements": {
        "field": "Password must contain at least one digit, one lowercase and one uppercase letter"
    },
    "maxLength": {
        "field": "This field must be no more than {{count}} characters long"
    },
    "minValue": {
        "field": "Value must be at least {{min}}"
    }
}